import { render, staticRenderFns } from "./salesslMaseg.vue?vue&type=template&id=92caeb04&scoped=true&"
import script from "./salesslMaseg.vue?vue&type=script&lang=js&"
export * from "./salesslMaseg.vue?vue&type=script&lang=js&"
import style0 from "./salesslMaseg.vue?vue&type=style&index=0&id=92caeb04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92caeb04",
  null
  
)

export default component.exports